<div class="flex flex-col gap-medpace">
    @if (mode() === 'view') {
        <div class="c-info__block">
            <h5>Special Requests</h5>
            <span>{{ formGroup().controls.specialRequests.value }}</span>
        </div>
    } @else if (mode() === 'edit') {
        <medpace-textarea-autocomplete
            id="specialRequests"
            [formCtrl]="formGroup().controls.specialRequests"
            [cdkAutosizeMaxRows]="20"
            [cdkAutosizeMinRows]="5"
            [label]="'Special Requests'"
            [placeholder]="'Special requests'"
            [appearance]="'outline'"
            [autoSize]="true"
            [options]="autocompleteOptions().specialRequests"
        />
    }
</div>
